export default __webpack_public_path__ + "static/media/js.d7863283.svg";